/**
 * Public catalogue viewer URL. Prefer backend publicUrl; otherwise
 * `/catalogue/{id}?link={token}` (same path the invite email uses).
 */
export function shareLinkPublicUrl(options: {
  catalogueId: string;
  linkToken?: string;
  publicUrl?: string;
  origin?: string;
}): string {
  const token = String(options.linkToken || "").trim();
  const backend = String(options.publicUrl || "").trim();
  if (backend) {
    return ensureLinkQuery(backend, token);
  }
  const origin = (options.origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(
    /\/+$/,
    ""
  );
  const path = `/catalogue/${encodeURIComponent(options.catalogueId)}`;
  if (!token) return `${origin}${path}`;
  return `${origin}${path}?link=${encodeURIComponent(token)}`;
}

export function ensureLinkQuery(url: string, linkToken: string): string {
  const token = String(linkToken || "").trim();
  if (!token) return url;
  try {
    const parsed = new URL(url);
    if (!parsed.searchParams.get("link")) {
      parsed.searchParams.set("link", token);
    }
    return parsed.toString();
  } catch {
    if (/[?&]link=/.test(url)) return url;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}link=${encodeURIComponent(token)}`;
  }
}
